import { AppError } from '@shared/api/error'
import type { UserFacingError } from '@shared/lib/errors/user-facing-error'
import { getUserFacingError } from '@shared/lib/errors/user-facing-error'

export type AffiliationRequestSource = 'marketplace' | 'invite'

const feedbackByCode: Record<string, UserFacingError> = {
  SelfAffiliationError: {
    title: 'Não foi possível solicitar a afiliação',
    description: 'Você não pode se afiliar ao seu próprio produto.',
  },
  AffiliateAgreementAlreadyExistsError: {
    title: 'Afiliação já existente',
    description: 'Você já possui uma afiliação com este produto. Consulte Minhas afiliações.',
  },
  ProductDoesNotAcceptAffiliatesError: {
    title: 'Produto indisponível para afiliação',
    description: 'Este produto não aceita novas afiliações.',
  },
  AffiliateRequiresMarketplaceOrInviteError: {
    title: 'Produto fora do marketplace',
    description:
      'Este produto não está mais disponível para afiliação pelo marketplace. Solicite um convite ao produtor.',
  },
  InvalidAffiliateInviteTokenError: {
    title: 'Convite inválido ou expirado',
    description: 'Solicite um novo convite ao produtor.',
  },
  InvalidPartnershipPercentageError: {
    title: 'Afiliação indisponível',
    description:
      'A comissão deste produto precisa ser corrigida pelo produtor antes de uma nova afiliação.',
  },
  ProductNotFoundError: {
    title: 'Produto não encontrado',
    description: 'Este produto não está mais disponível.',
  },
  PartnershipReceivingBlockedError: {
    title: 'Afiliação indisponível',
    description:
      'Um dos participantes ainda não está habilitado a receber pagamentos. Confira sua conta e, se estiver regular, fale com o produtor.',
  },
}

const fallbackBySource: Record<AffiliationRequestSource, UserFacingError> = {
  marketplace: {
    title: 'Não foi possível solicitar a afiliação',
    description: 'Tente novamente em alguns instantes.',
  },
  invite: {
    title: 'Convite não aplicado',
    description: 'Confira o link e tente novamente.',
  },
}

export function affiliationRequestErrorFeedback(
  error: unknown,
  source: AffiliationRequestSource,
): UserFacingError {
  if (!(error instanceof AppError)) return fallbackBySource[source]

  if (
    error.code === 'AffiliateDocumentationNotApprovedError' ||
    error.code === 'PartnershipRoleConflictError'
  )
    return getUserFacingError(error)

  const mapped = feedbackByCode[error.code]
  if (mapped) return mapped

  if (error.status === 401 || error.status === 403 || error.status === 429 || error.status >= 500) {
    return getUserFacingError(error)
  }

  return fallbackBySource[source]
}
